import invariant from 'invariant';
import cond from 'lodash/cond';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import identity from 'lodash/identity';
import stubTrue from 'lodash/stubTrue';
import stubFalse from 'lodash/stubFalse';
export default function ensureStrategy(strategyCandidate) {
  var strategy = cond([[isArray, identity], [isString, function (x) {
    return [x, []];
  }], [stubTrue, stubFalse]])(strategyCandidate);
  invariant(strategy !== false, "Invalid strategy definition '".concat(strategyCandidate, "' found. Strategy definition have to be `tuple` or `string`."));
  return strategy;
}